import React, { useContext } from 'react'

export type SSRAppleBannerConfig = {
  appleSmartBannerContent: string | null
}

const SSRAppleBannerContext = React.createContext<SSRAppleBannerConfig>({
  appleSmartBannerContent: null
})

export type Props = {
  appleSmartBannerContent: string | null
}

/**
 * Context provider for Apple Smart Banner content from server-side rendering.
 * The content string is determined server-side based on:
 * - Whether the request is for a Toast Local page
 * - Whether the feature flag is enabled
 * - The current request URL for deep linking
 */
export const SSRAppleBannerContextProvider = ({
  appleSmartBannerContent,
  children
}: React.PropsWithChildren<Props>) => {
  const context = {
    appleSmartBannerContent
  }
  return (
    <SSRAppleBannerContext.Provider value={context}>
      {children}
    </SSRAppleBannerContext.Provider>
  )
}

export const useSSRAppleBannerContext = () => {
  return useContext(SSRAppleBannerContext)
}
